import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '2px',
    width: '120px',
    padding: '4px',
    backgroundColor: 'white',
    border: '1px solid #999999',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    position: 'fixed',
    zIndex: 9999
  },
  emojiButton: {
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    cursor: 'pointer',
    backgroundColor: 'white',
    border: 'none',
    padding: '2px',
    '&:hover': {
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  }
}))

const EmojiPickerRef = React.forwardRef(function EmojiPicker(props, ref) {
  const classes = useStyles(props)
  const emojiList = ['🙂', '😀', '😐', '🤩', '👍', '👎', '🤔', '😬', '😮', '❤️', '🙁', '😠', '🙏', '😂', '👆', '👇']

  useEffect(() => {
  }, []);

  return (
    <div className={classes.root} ref={ref}>
      {emojiList.map((emoji, index) => (
        <button
          className={classes.emojiButton}
          key={index}
          onClick={() => {
            props.onSelect({ native: emoji });
          }}
        >
          {emoji}
        </button>
      ))}
    </div>
  )
})

export default EmojiPickerRef
